import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { Glow } from '@/shared/ui/glow'
import { ShopItemType } from '@/entities/cases'
import { ShopItem } from '@/features/shopItem'
import { useMemo } from 'react'

type ShopItemListProps = {
  items: ShopItemType[]
}

export const ShopItemList = (props: ShopItemListProps) => {
  const { classes } = useStyles()
  const { items } = props

  const sortedItems = useMemo(() => items.sort((a, b) => b.amount - a.amount), [items])

  const hotItems = sortedItems.slice(0, 3)
  const otherItems = sortedItems.slice(3)
  const userLang = useUnit($userLanguage)
  const texts = lang[userLang].pages.shop

  return (
    <div className={classes.root}>
      <div className={classes.specialOfferItems}>
        {hotItems.map((item, index) => (
          <ShopItem
            {...item}
            isBestOffer
            variant={index === 1 ? 'percentile' : undefined}
          />
        ))}
        <Glow
          background={'#FF8000'}
          width={'40%'}
          height={'40%'}
          filter="blur(90px)"
          bottom={'40%'}
        />
      </div>
      <div className={classes.regularItemsWrapper}>
        <h1>{texts.standardBundles}</h1>
        <div className={classes.regularOfferItems}>
          {otherItems.map((item, index) => (
            <ShopItem
              {...item}
              isBestOffer={false}
              variant={index === 4 ? 'hot' : undefined}
            />
          ))}
        </div>
      </div>
    </div>
  )
}
